enum Model {
    'F350'
}

export default Model